import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import React from "react";
import Select from "react-select";
import { columnsCsv } from "./registrationaldetails/content";
import { getManageuserdata } from "./manageuserVerification/mockdata";
import Loading from "../loader/loader";

const DeleteUser = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure, you want to delete ?</Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          color="primary"
          onClick={() => props.onDelete()}
        >
          {props.deleteLoader ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUser;
